import { ColumnDef } from "@tanstack/react-table";

import { createColumns } from "@/helpers/tableHelper";
import { UserDetailFlat } from "@/types/user";

import { BADGE_LABEL_STATUS_MAP, BADGE_VARIANT_STATUS_MAP } from "./data";

type ColumnsProps = {
  handleShowEditUserPanel: (data: UserDetailFlat) => void;
  handleShowViewUserPanel: (data: UserDetailFlat) => void;
  handleDeleteUser: (data: UserDetailFlat) => void;
  isViewUserGranted: boolean;
  isDeleteUserGranted: boolean;
  isEditUserGranted: boolean;
  isMultipleUserGroupAssignmentEnabled: boolean;
  timezone?: {
    code: string;
    name: string;
  };
};

export const columns = ({
  handleShowViewUserPanel,
  handleShowEditUserPanel,
  handleDeleteUser,
  isViewUserGranted,
  isDeleteUserGranted,
  isEditUserGranted,
  isMultipleUserGroupAssignmentEnabled,
  timezone
}: ColumnsProps): ColumnDef<UserDetailFlat, string>[] => {
  const {
    textColumn,
    dateColumn,
    statusColumn,
    actionColumn,
    lastActiveColumn
  } = createColumns<UserDetailFlat>(
    {
      statusMappings: {
        variant: BADGE_VARIANT_STATUS_MAP,
        label: BADGE_LABEL_STATUS_MAP
      },
      handleEditAction: handleShowEditUserPanel,
      handleViewAction: handleShowViewUserPanel,
      handleDeleteAction: handleDeleteUser,
      viewPermission: isViewUserGranted,
      deletePermission: isDeleteUserGranted,
      editPermission: isEditUserGranted
    },
    timezone
  );

  const groupNamesColumn: ColumnDef<UserDetailFlat, string> = {
    ...textColumn({ key: "group_name", title: "Group", maxSize: 200 }),
    cell: ({ row }) => (
      <p
        className="text-xs whitespace-normal break-words line-clamp-2"
        title={row.original.group_names.join(", ")}
      >
        {row.original.group_names.join(", ")}
      </p>
    )
  };

  return [
    textColumn({ key: "fullname", title: "Name", maxSize: 200 }),
    textColumn({ key: "email_address", title: "Email address", maxSize: 200 }),
    isMultipleUserGroupAssignmentEnabled
      ? groupNamesColumn
      : textColumn({ key: "group_name", title: "Group", maxSize: 200 }),
    lastActiveColumn({
      key: "last_signin_at",
      title: "Last sign in",
      maxSize: 200
    }),
    dateColumn({ key: "created_at", title: "Created at", timezone }),
    textColumn({ key: "created_by", title: "Created by", maxSize: 200 }),
    dateColumn({ key: "updated_at", title: "Modified at", timezone }),
    textColumn({ key: "updated_by", title: "Modified by", maxSize: 200 }),
    statusColumn({ maxSize: 200 }),
    actionColumn({ maxSize: 62 })
  ];
};
